import React, { lazy, Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter, } from 'react-router-dom';
import { Provider } from 'react-redux';
import { register, unregister } from '../serviceWorkerRegistration';
import { configureStore } from './store';
import initGoogleAnalytics from './utils/initGoogleAnalytics';
const App = lazy(() => import('./App'));
const ErrorBoundary = lazy(() => import('./components/ErrorBoundering'));
initGoogleAnalytics();
const store = configureStore;
const container = document.getElementById('root');
if (container) {
    const root = createRoot(container);
    const AppDOM = () => {
        if (typeof window !== 'undefined' && window.location.href.includes('.brixel.io'))
            register();
        if (typeof window !== 'undefined' && window.location.href.includes('localhost'))
            unregister();
        return (<>
        <Provider store={store}>
          <BrowserRouter>
            <Suspense>
              <ErrorBoundary>
                <App />
              </ErrorBoundary>
            </Suspense>
          </BrowserRouter>
        </Provider>
      </>);
    };
    root.render(<AppDOM />);
}
